/**
 * @namespace Queue
 * @aka PIANO.Queue
 *
 */
PIANO.Queue = function (window, document) {

  var SUBMIT_QUEUE_TIMEOUT_MS = 5 * 1000;

  var submitQueueTimeoutID;

  var eventsQueue = [];

  var isLocked = false;

  /**
   *
   * @param {Object} eventObject
   */
  var push = function push(eventObject) {
    if (isLocked) {
      window.setTimeout(function () {
        push(eventObject);
      }, 50);
      return;
    }

    console.debug('Tracking Piano Queue: `push`', eventObject);
    eventsQueue.push(eventObject);

    /*
     * Ab 25 Einträgen wird sofort übermittelt
     */
    if (25 <= eventsQueue.length) {
      submitQueue();
    } else if (!submitQueueTimeoutID) {
      /*
       * Ansonsten wird spätestens nach 5 Sekunden übermittelt
       */
      submitQueueTimeoutID = window.setTimeout(function () {
        submitQueue();
      }, SUBMIT_QUEUE_TIMEOUT_MS);
    }
  }

  var submitQueue = function submitQueue() {
    if (0 === eventsQueue.length) {
      return;
    }

    isLocked = true;

    try {
      console.debug('Tracking Piano Queue: `sendEvents`', eventsQueue);

      if (submitQueueTimeoutID) {
        window.clearTimeout(submitQueueTimeoutID);
        submitQueueTimeoutID = (function () {
        })();
      }

      _paq.push([
        'sendEvents',
        eventsQueue
      ]);

      eventsQueue = [];
    } catch (e) {
      /* noop */
    } finally {
      isLocked = false;
    }
  }

  document.addEventListener('piano:beforeReplace', function () {
    submitQueue();
  });
  document.addEventListener('piano:beforeunload', function () {
    submitQueue();
  });
  document.addEventListener('piano:pagehide', function () {
    submitQueue();
  });

  /**
   * --------------------------------------------------------------------------
   * Public Pageview Api
   * --------------------------------------------------------------------------
   */
  return {
    push: push
  };

}(window, document);
